import { useBackend } from "../../services";

export const useGetDiscogsCollectionFolders = () => {
  const { get } = useBackend();
  return async (username: string) => {
    return await get(`discogs/collection/folders/${username}`);
  };
};
